import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {WELCOME} from "@core/services/routes.service";
import {UserRestService} from "@core/modules/rest/user/user-rest.service";
import {TermsAndConditionsResponseModel} from "@core/modules/rest/user/response/terms-and-conditions-response.model";

@Injectable({
    providedIn: 'root',
})
export class NoAccessDataProcessingGuard implements CanActivate {

    constructor(protected readonly userService: UserRestService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.userService.checkTermsAndConditions().pipe(map((data: TermsAndConditionsResponseModel) => {
            if (data !== null && data) {
                return this.router.createUrlTree([WELCOME]);
            } else {
                return true;
            }
        }));
    }

}
